import { isLoaded } from "common/loader/isLoaded";
import { AppState } from "features";

export const getAnalyticsDashboarUrl = (state: AppState) =>
    isLoaded(state.analytics.dashboardUrl) ? state.analytics.dashboardUrl.data : null;
